import jsonLogic from 'json-logic-js'
import { parseDateString } from './moment'
import moment from 'moment'
import i18n from '@/i18n/i18n'
import L from 'lodash'

/**
 * Custom logic to compute the difference between 2 dates/times:
 * - the logic will attempt to detect the string format between the commonly used in Agilis (date, datetime or time)
 * - the dates can be expressed also using key words (now, todayEOD - end of day, todayBOD -begin of day)
 * - the 3rd parameter is the expected diff measure between the measures supported by momentJS (years, months, days etc...)
 * {
 *  "momentDiff": [
 *    {"var": "startDate"},
 *    "todayBOD",
 *    "days"
 *   ]
 * }
 */
jsonLogic.add_operation('momentDiff', (a, b, measure = 'seconds') => {
  const m1 = parseDateString(a)
  const m2 = parseDateString(b)

  const validMeasure = [
    'years',
    'months',
    'weeks',
    'days',
    'hours',
    'minutes',
    'seconds'
  ]
  if (validMeasure.indexOf(measure) === -1) {
    throw new Error('momentDiff: Invalid measure')
  } else if (!m1 || !m2) {
    throw new Error('momentDiff: Invalid input dates')
  }

  return m1.diff(m2, measure)
})

jsonLogic.add_operation('percentage', (num) => {
  return parseInt(num * 100, 10) || 0
})

jsonLogic.add_operation('catUrl', (...args) => {
  const _args = args.map(a => {
    if (a && typeof a === 'object') return a.id
    return a
  })
  if (
    _args.some(a => (
      a === null ||
      a === undefined
    ))
  ) return null
  return _args.join('')
})

jsonLogic.add_operation('catWithSeparator', (separator, ...args) => {
  const elements = L.compact(args)
  return elements.join(separator)
})

jsonLogic.add_operation('i18n', (label) => {
  return i18n.t(label)
})

jsonLogic.add_operation('dateMin', (...args) => {
  const dates = args.reduce((result, arg) => {
    const date = parseDateString(arg)
    if (date?.isValid()) {
      result.push(date)
    }
    return result
  }, [])
  const minDate = dates.length > 0 ? moment.min(...dates) : null
  return minDate?.isValid() ? minDate.format('YYYY-MM-DD') : ''
})

jsonLogic.add_operation('dateMax', (...args) => {
  const dates = args.reduce((result, arg) => {
    const date = parseDateString(arg)
    if (date?.isValid()) {
      result.push(date)
    }
    return result
  }, [])
  const maxDate = dates.length > 0 ? moment.max(...dates) : null
  return maxDate?.isValid() ? maxDate.format('YYYY-MM-DD') : ''
})

jsonLogic.add_operation('render', function (colId) {
  let data = null
  const item = this
  if (item.renderColumn) {
    data = item.renderColumn(colId, item)
  }
  return data || item[colId]
})

jsonLogic.add_operation('replace', (data, pattern, replacement) => {
  if (data === undefined || pattern === undefined || replacement === undefined) {
    throw new Error('Invalid input: data, pattern and replacement must be defined')
  }
  const regex = new RegExp(pattern, 'g')
  const result = data?.toString().replace(regex, replacement)

  return result
})

jsonLogic.add_operation('isEmpty', function (obj) {
  if (typeof obj === 'object') return L.isEmpty(obj)
  return !obj
})

export default jsonLogic
